export default {
  'meta': {
    'langName': 'SLOVAK',
    'lang': 'Slovenčina'
  },
  'title': 'STIAHNUTIE PRODUKTU Z PREDAJA: BASKETBALOVÝ KÔŠ B900 BOX NBA TARMAK',
  'description': 'Dobrý deň, \n\n\nNedávno ste zakúpili basketbalový kôš Tarmak B900 BOX NBA a ďakujeme Vám za Váš nákup.\n\nV rámci nášho trvalého záväzku ku kvalite a bezpečnosti produktov, tím DECATHLON Basketball zistil potenciálne riziko pádu vertikálnej tyče, ak sa odstráni kľuka na nastavenie výšky a s produktom sa manipuluje alebo sa používa. \n\nProsíme Vás, aby ste odpovedali na niekoľko otázok, aby sme Vám mohli poskytnúť vhodné bezpečnostné riešenie pre Váš produkt.\n\nOspravedlňujeme sa za nepríjemnosti a ďakujeme Vám za dôveru.\n\nDECATHLON\n\n',
  'emailConfirmation': {
    'title': 'Najskôr, prosím, potvrďte svoju e-mailovú adresu a krajinu bydliska:'
  },
  'fields': {
    'country': 'Krajina',
    'address': 'E-mail',
    'email': 'E-mail',
    'phonePrefix': 'Predvoľba telefónneho čísla',
    'phone': 'Telefónne číslo',
    'validations': {
      'phoneOrEmail': 'Uveďte aspoň e-mailovú adresu alebo telefónne číslo.',
      'email': 'Zadajte platnú e-mailovú adresu',
      'phone': 'Zadajte platné telefónne číslo'
    },
    'firstName': 'Priezvisko',
    'lastName': 'Meno',
    'deliveryAddress': 'Adresa pre doručenie zásielky',
    'additionalAddress': 'Doplňujúce údaje o adrese',
    'city': 'Mesto',
    'zip': 'Poštové smerové číslo',
    'choose': 'Vybrať',
    'required': 'Toto pole je povinné'
  },
  'ownerCheck': {
    'title': 'Stále vlastníte jeden alebo viac basketbalových košov B900 BOX NBA?'
  },
  'yes': 'ÁNO',
  'no': 'NIE',
  'ownerChanged': {
    'title': 'Máte kontaktné údaje súčasného vlastníka (vlastníkov)?',
    'confirmation': 'Vážený pán/vážená pani,\n\nďakujeme Vám za účasť v tejto iniciatíve zameranej na kvalitu.\nOspravedlňujeme sa za spôsobené nepríjemnosti a ďakujeme Vám za Vašu dôveru.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Uveďte počet basketbalových košov, ktoré máte, podľa typu nainštalovanej kľuky.',
    'descriptionRed': 'Basketbalový kôš s odnímateľnou červenou kľukou',
    'descriptionBlack': 'Basketbalový kôš s pevnou čiernou kľukou',
    'quantity': 'Množstvo',
    'notConcerned': 'Vážený pán/vážená pani,\nďakujeme Vám za účasť v tejto iniciatíve zameranej na kvalitu.\nMôžete si byť istí, že Váš basketbalový kôš Tarmak B900 BOX NBA nie je súčasťou procesu stiahnutia z trhu. Jeho používanie je bezpečné.\n\nOspravedlňujeme sa za spôsobené nepríjemnosti a ďakujeme Vám za Vašu dôveru.\n\n\nDECATHLON',
    'concernedProductQuantity': 'Množstvo nezhodného produktu:',
    'concernedProductLabel': 'Nezhodný produkt:',
    'confirmation': 'Ďakujeme za vyplnenie tohto formulára. Vaša žiadosť bola úspešne zaznamenaná.\nČíslo sledovania zásielky s Vašou opravnou sadou Vám zašleme čo najskôr (prostredníctvom FandiWeb pre európske krajiny).\nPrajeme vám pekný deň.\n\n\nDECATHLON'
  },
  'repair': {
    'title': 'Oprava s vašou účasťou',
    'description': 'Zistili sme riziko pádu vertikálnej tyče na určitých basketbalových košoch TARMAK B900 BOX NBA, číslo produktu: 4239136, v prípade, ak sa odstráni kľuka a produkt sa používa alebo sa s ním manipuluje.\n \nNa základe vašej odpovede sa zdá, že tento rizikový faktor sa týka aj vášho produktu.\nPreto vás žiadame, aby ste ho ihneď prestali používať a ponúkame vám pomoc pri úprave kľuky, aby ste mohli produkt bezpečne používať.\nUisťujeme vás, že táto oprava nevyžaduje žiadne špeciálne znalosti – všetko je jasne vysvetlené v nižšie uvedenom videu a návode na použitie:',
    'videoLink': 'Odkaz na video',
    'docLink': 'Odkaz na návod',
    'callToAction': 'Kliknite sem a získajte bezplatnú opravnú sadu',
    'warranty': 'Na celý proces sa vzťahuje naša 5-ročná záruka.'
  },
  'repairRequest': {
    'title': 'Aby sme vám mohli zaslať bezplatnú sadu na adresu podľa vášho výberu, zadajte nasledujúce informácie:'
  },
  'form': {
    'submit': 'Ďalej '
  },
  'status': 'Translation validated by COUNTRY'
} as const
